
import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class ExportServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getFiles(params) {
    return this.pure_http.post('pbx/recordings/export', params);
  }

}

export const ExportService = new ExportServiceClass({
  api_version: 2,
  resource: 'pbx/stats'
});
